var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2927_10031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 6.83464C1.33398 5.40269 2.56435 4.2795 3.99583 4.31608C5.14178 4.34536 6.42434 4.32732 7.33398 4.16797C9.52505 3.78413 12.0007 2.16797 12.0007 2.16797V11.5013C12.0007 11.5013 9.52505 9.88514 7.33398 9.5013C6.42434 9.34195 5.14178 9.32391 3.99583 9.35319C2.56435 9.38977 1.33398 8.26658 1.33398 6.83464Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6672 13.4055V9.87853C7.96074 9.56416 6.01833 9.01966 3.90039 9.35661L6.82395 13.943C7.3615 14.7863 8.6672 14.4055 8.6672 13.4055Z",
    fill: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2927_10031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.167969)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingCount);
export default __webpack_public_path__ + "static/media/rating-count.4e282bc533534f2cb5c41b997a16cce1.svg";
export { ForwardRef as ReactComponent };